import * as api from "../generated-api";
import { apiCall } from "../common";

export const getCompanyByOrgId = (
  orgId: number,
  successCallback?: (company: api.Company) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Company>(
    () => {
      return api.getCompany(orgId);
    },
    successCallback,
    errorCallback
  );
};

export const updateCompany = (
  orgId: number,
  companyUpdate: api.CompanyUpdate,
  successCallback?: (company: api.Company) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Company>(
    () => {
      return api.updateCompany(orgId, companyUpdate);
    },
    successCallback,
    errorCallback
  );
};

export const getCompanyLawFirms = (
  orgId: number,
  successCallback?: (lawFirmClients: api.LawFirmClient[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.LawFirmClient[]>(
    () => {
      return api.getCompanyLawFirms(orgId);
    },
    successCallback,
    errorCallback
  );
};

export const updateCompanyLawFirmClient = (
  companyOrgId: number,
  lawFirmClientId: number,
  updateData: api.UpdateLawFirmClient,
  successCallback?: (lawFirmClients: api.LawFirmClient) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.LawFirmClient>(
    () => {
      return api.updateCompanyLawFirmClient(
        companyOrgId,
        lawFirmClientId,
        updateData
      );
    },
    successCallback,
    errorCallback
  );
};

export const getCompanyMembers = (
  companyOrgId: number,
  successCallback?: (members: api.LegalEntity[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.LegalEntity[]>(
    () => {
      return api.getCompanyMembers(companyOrgId);
    },
    successCallback,
    errorCallback
  );
};
